import React, { createContext, useEffect, useState, useRef, useContext } from 'react'
import DeviceLogin from '../components/DeviceLogin'
import { localStorage } from 'okeoke.localstorage'
import { deviceLogin } from '../api/deviceLogin'
import { DeviceTypes } from '../orderengine-client'
import { OkeNavProvider } from './OkeNavContext'
import { OkeFrameContext } from './OkeFrameContext'
import { OkeScaleProvider } from './OkeScaleContext'
import { UUID } from "uuidjs";

const OkeDeviceContext = createContext()

const getSearchValues = () => {
  let searchParsed = (window.location.search || '').replace('?', '').split('&')
  let searchValues = {}
  for (let val of searchParsed) {
    let [key, value] = val.split('=')
    searchValues[key] = value
  }
  searchValues.previewMode = searchValues?.previewMode === '1' ? true : false
  return searchValues
}

const OkeDeviceProvider = (props) => {
  const searchValues = getSearchValues()
  const { sendMessageToWebView } = useContext(OkeFrameContext)
  const { prefix, children, title, types, onTokenStateDetermined, CustomDeviceLogin = null } = props
  const [hasDeviceContext] = useState(true)
  const [brandID, setBrandID] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-brand-id`) : null)
  const [deviceUUID, setDeviceUUID] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-uuid`) : null)
  const [parentDeviceUUID, setParentDeviceUUID] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-parent-uuid`) || null : null)
  const [deviceType, setDeviceType] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-type`) : null)
  const [deviceParams, setDeviceParams] = useState((!searchValues?.previewMode) ? JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-params`) || '{}') : null)
  const [devicePaymentAgents, setDevicePaymentAgents] = useState((!searchValues?.previewMode) ? JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-pa`) || '[]') : null)
  const [deviceName, setDeviceName] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-name`) : null)
  const [deviceLocationUUID, setDeviceLocationUUID] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-location-uuid`) : null)
  const [token, setToken] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-token`) : null)
  const [tokenType, setTokenType] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-token-type`) : null)
  const [expires, setExpires] = useState((!searchValues?.previewMode) ? +localStorage.getItem(`okeoke-${prefix || '0'}-device-token-expires`) : 0)
  const [apiUrl, setApiUrl] = useState((!searchValues?.previewMode) ? localStorage.getItem(`okeoke-${prefix || '0'}-device-apiurl`) : null)
  const [deviceDemo, setDeviceDemo] = useState((!searchValues?.previewMode) ? +localStorage.getItem(`okeoke-${prefix || '0'}-device-demo`) : 0)
  const [deviceSandbox, setDeviceSandbox] = useState((!searchValues?.previewMode) ? +localStorage.getItem(`okeoke-${prefix || '0'}-device-sandbox`) : 0)
  const [loading, setLoading] = useState(true)
  const [loggedIn, setLoggedIn] = useState(false)
  const [loggedInUser, setLoggedInUser] = useState(null)
  const [error, setError] = useState(null)
  const [disabled, setDisabled] = useState(false)

  const [reseller, setReseller] = useState(JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-reseller`) || '{}'))
  const [attributes, setAttributes] = useState(JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-attributes`) || '{}'))

  const [subDevices, setSubDevices] = useState((!searchValues?.previewMode) ? JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-sub-devices`) || '[]') : null)

  const [previewMode, setPreviewMode] = useState(false)

  const [requestCode, setRequestCode] = useState('')
  const timeoutRef = useRef(null)
  const codeRef = useRef(null)
  const [clientUID, setClientUID] = useState(localStorage.getItem('0000-cuid'))

  const [localUsers, setLocalUsers] = useState(JSON.parse(localStorage.getItem(`okeoke-${prefix || '0'}-device-users`) || '[]'))

  const tokenStateDetermined = (valid) => {
    if (!valid && timeoutRef.current == null) {
      timeoutRef.current = setTimeout(checkRemoteLogin, 1000)
    }
    if (valid && timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    if (typeof onTokenStateDetermined === 'function') {
      onTokenStateDetermined(valid)
    }
  }

  const initClientUID = () => {
    let currentUID = localStorage.getItem('0000-cuid')
    if (currentUID == null) {
      const newUID = UUID.generate()
      setClientUID(newUID)
      localStorage.setItem('0000-cuid', newUID)
    } else {
      setClientUID(currentUID)
    }
  }

  useEffect(() => {
    initClientUID()
    let loc = window.location
    let splitPath = loc.pathname.split('/')
    let action = (splitPath[splitPath.length - 1] === '' ? splitPath[splitPath.length - 2] : splitPath[splitPath.length - 1])
    if (action === 'initDevice') {
      let apiUrl = `https://${loc.host}`
      let token = searchValues?.t || null
      if (apiUrl != null && token != null) {
        onLogin(token, apiUrl)
        let deviceName = (splitPath[0] === '' ? splitPath[1] : splitPath[0])
        setTimeout(() => window.history.replaceState({}, "Activated", `/${deviceName}`), 1000)
      }
    }
  })

  useEffect(() => {
    if (deviceParams != null) {
      localStorage.setItem(`okeoke-${prefix || '0'}-device-params`, JSON.stringify(deviceParams))
    }
  }, [deviceParams])

  useEffect(() => {
    if (devicePaymentAgents != null) {
      localStorage.setItem(`okeoke-${prefix || '0'}-device-pa`, JSON.stringify(devicePaymentAgents))
    }
  }, [devicePaymentAgents])

  useEffect(() => {
    if (subDevices != null) {
      localStorage.setItem(`okeoke-${prefix || '0'}-device-sub-devices`, JSON.stringify(subDevices))
    }
  }, [subDevices])

  useEffect(() => {
    if (localUsers != null) {
      localStorage.setItem(`okeoke-${prefix || '0'}-device-users`, JSON.stringify(localUsers))
    }
  }, [localUsers])

  useEffect(() => {
    if (clientUID != null) {
      if (searchValues?.previewMode === 1 && searchValues?.apiUrl != null && searchValues?.brandID != null) {
        setDeviceType(searchValues?.deviceType || 1)
        setApiUrl(searchValues?.apiUrl || 'https://pnrvqvmru.okeoke.io')
        setBrandID(searchValues?.brandID || 'PNRVqVMRU')
        setLoading(false)
        setLoggedIn(true)
        tokenStateDetermined(true)
        setPreviewMode(true)
      }
      if (!(+searchValues?.previewMode === 1)) {
        if (apiUrl != null && token != null && clientUID != null) {
          deviceLogin.checkDevice(apiUrl, token, clientUID).then(checkRes => {
            console.log(checkRes)
            if (checkRes?.success) {
              if (checkRes?.data?.deviceState?.connected && checkRes?.data?.deviceState?.deviceInfo?.clientUID !== clientUID) {
                setLoading(false)
                tokenStateDetermined(false)
                setError({ message: 'Másik készüléken aktiválva lett ez a licensz (1 eszköz egyszerre 1 készüléken lehet aktiválva).' })
              } else {
                deviceLogin.refreshDeviceToken(apiUrl, token).then(res => {
                  if (res.success) {
                    if (!res.data?.enabled) {
                      setLoading(false)
                      tokenStateDetermined(false)
                      setError({ message: 'Ez az eszköz jelenleg nincs engedélyezve.' })
                    } else {
                      sendMessageToWebView({
                        action: 'setAppUrl',
                        data: { url: `${apiUrl}/${DeviceTypes[res.data.deviceType]}/`, url2: `${apiUrl}/secondScreen/` }
                      })
                      setLoading(false)
                      setBrandID(res.data.brandID)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-brand-id`, res.data.brandID)
                      setDeviceUUID(res.data.uuid)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-uuid`, res.data.uuid)
                      setParentDeviceUUID(res.data.parentDeviceUUID)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-parent-uuid`, res.data?.parentDeviceUUID || null)
                      setDeviceType(res.data.deviceType)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-type`, res.data.deviceType)
                      setDeviceParams(res.data.deviceParams)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-params`, JSON.stringify(res.data.deviceParams || {}))

                      setReseller(res.data.reseller || {})
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-reseller`, JSON.stringify(res.data.reseller || {}))
                      setAttributes(res.data.attributes || {})
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-attributes`, JSON.stringify(res.data.attributes || {}))


                      setDevicePaymentAgents(res.data.paymentAgents)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-pa`, JSON.stringify(res.data.paymentAgents || []))
                      setSubDevices(res.data.subDevices)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-sub-devices`, JSON.stringify(res.data.subDevices || []))
                      setDeviceName(res.data.deviceName)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-name`, res.data.deviceName)
                      setDeviceDemo(res.data.demo || 0)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-demo`, res.data.demo || 0)
                      setDeviceSandbox(res.data.sandbox || 0)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-sandbox`, res.data.sandbox || 0)
                      setDeviceLocationUUID(res.data.locationUUID)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-location-uuid`, res.data.locationUUID)
                      setExpires(res.expires)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-token-expires`, new Date(res.expires).getTime())
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-token`, res.token)
                      setTokenType(res.type)
                      localStorage.setItem(`okeoke-${prefix || '0'}-device-token-type`, res.type)
                      setLoggedIn(true)
                      tokenStateDetermined(true)
                    }
                  } else {
                    setLoading(false)
                    if (res.code === 500 && expires > 0) {
                      var expiresDate = new Date().setTime(expires)
                      var currentDate = new Date().getTime()
                      console.log('1', { expiresDate, currentDate })
                      if (expiresDate > currentDate) {
                        console.log('1', 'OK')
                        setLoggedIn(true)
                        tokenStateDetermined(true)
                      } else {
                        console.log('1', 'NO')
                        tokenStateDetermined(false)
                        localStorage.clear()
                      }
                    } else {
                      tokenStateDetermined(false)
                    }
                  }
                })
              }
            } else {
              if (checkRes.code === 500) {
                setLoading(false)
                var expiresDate = new Date().setTime(expires)
                var currentDate = new Date().getTime()
                console.log('2', { expiresDate, currentDate })
                if (expiresDate > currentDate) {
                  console.log('2', 'OK')
                  setLoggedIn(true)
                  tokenStateDetermined(true)
                } else {
                  console.log('2', 'NO')
                  tokenStateDetermined(false)
                  localStorage.clear()
                }
              } else {
                setLoading(false)
                tokenStateDetermined(false)
              }
            }
          })
        } else {
          setLoading(false)
          tokenStateDetermined(false)
        }
      }
      return () => {
        // ON UNMOUNT
      }
    }
  }, [apiUrl, token, clientUID])

  const onRemoteLogin = (token, apiUrl, app) => {
    let appName = DeviceTypes[app]
    if (window.location.host === 'activate.app.barsoft.hu') {
      window.location.replace(`${apiUrl}/${appName}/initDevice?t=${token}`);
    } else {
      localStorage.setItem(`okeoke-${prefix || '0'}-device-token`, token)
      localStorage.setItem(`okeoke-${prefix || '0'}-device-apiurl`, apiUrl)
      window.location.reload()
    }
  }

  const checkRemoteLogin = () => {
    deviceLogin.remoteDeviceLogin(codeRef.current).then(res => {
      if (res.success) {
        codeRef.current = res.data.code
        setRequestCode(codeRef.current)
        if (res.data.auth?.token != null) {
          if (types.includes(res.data.auth?.deviceType)) {
            onRemoteLogin(res.data.auth?.token, res.data.auth?.apiUrl, res?.data?.auth?.deviceType)
            setError(null)
          } else {
            setError({ message: 'Accepted: ' + types.map(ty => ' ' + DeviceTypes[ty]) + ' Requested: ' + DeviceTypes[res?.data?.auth?.deviceType] })
          }
        }
      }
      timeoutRef.current = setTimeout(checkRemoteLogin, 5000)
    })
  }

  const checkPin = (pin) => {
    if (pin && pin.length >= 4) {
      setError(null)
      deviceLogin.generateDeviceToken(pin).then(res => {
        if (res.success) {
          if (types.includes(res?.data?.info?.deviceType)) {
            onRemoteLogin(res.data.token, res.data.info.apiUrl, res?.data?.info.deviceType)
            setError(null)
          } else {
            setError({ message: 'Accepted: ' + types.map(ty => ' ' + DeviceTypes[ty]) + ' Requested: ' + DeviceTypes[res?.data?.info?.deviceType] })
          }
        } else {
          setError(res)
        }
      }).catch(err => {
        console.log(err)
        setError({ message: 'Something went wrong. Is the device connected?' })
      })
    }
  }

  const onLogin = (token, apiUrl) => {
    setToken(token)
    setApiUrl(apiUrl)
    localStorage.setItem(`okeoke-${prefix || '0'}-device-token`, token)
    localStorage.setItem(`okeoke-${prefix || '0'}-device-apiurl`, apiUrl)
  }

  const logoffDevice = () => {
    localStorage.clear()
    setLoggedIn(false)
    window.location.reload()
  }

  return (
    <OkeDeviceContext.Provider
      value={{
        hasDeviceContext, logoffDevice, loggedIn, brandID,
        deviceUUID, deviceType, deviceParams, setDeviceParams, setDevicePaymentAgents, deviceDemo, deviceSandbox,
        subDevices, setSubDevices, setDeviceName,
        devicePaymentAgents, deviceName, deviceLocationUUID,
        expires, token, tokenType, apiUrl, prefix, loggedInUser,
        setLoggedInUser, previewMode, clientUID, setDisabled, sendMessageToWebView,
        parentDeviceUUID, reseller, attributes, localUsers, setLocalUsers
      }}
    >
      <OkeNavProvider deviceParams={deviceParams}>
        <OkeScaleProvider deviceParams={deviceParams} sendMessageToWebView={sendMessageToWebView}>
          {!disabled && !loading && !loggedIn && (CustomDeviceLogin != null ?
            <CustomDeviceLogin onLogin={onLogin} onRemoteLogin={onRemoteLogin} title={title} types={types} error={error} requestCode={requestCode} checkPin={checkPin} /> :
            <DeviceLogin onLogin={onLogin} onRemoteLogin={onRemoteLogin} title={title} types={types} error={error} requestCode={requestCode} checkPin={checkPin} />)}
          {!disabled && !loading && loggedIn && children}
          {disabled && (CustomDeviceLogin ? <CustomDeviceLogin deviceDisabled={true} /> : <DeviceLogin deviceDisabled={true} />)}
        </OkeScaleProvider>
      </OkeNavProvider>
    </OkeDeviceContext.Provider>
  )
}

export { OkeDeviceContext, OkeDeviceProvider }
